<template>
  <div class="phonePage05" :style="bg">
    <div class="pb_box">
      <div class="pb_bg">
        <img :style="{ 'animation-duration': (index % 3) / 2 + 2 + 's' }" v-for="(item, index) in $tools.localStorageFn
          .get('PAGE_DATE')
          .banner7.slice(0, 15)" :key="index" :src="imgUrl + item" alt="" />
      </div>
      <div class="pb_area">
        <div class="pb_title">{{ title }}</div>
        <p class="pb_label">
          {{ $tools.localStorageFn.get("PAGE_DATE").banner7_content }}
        </p>
        <div class="t_box_btn" @click="$router.push('/mobileJingzheWelfare')">
          了解更多
        </div>
      </div>
    </div>

    <floatService style="position: absolute;"></floatService>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: {
        background:
          "url(" +
          this.imgUrl +
          this.$tools.localStorageFn.get("PAGE_DATE").banner7_background +
          ") no-repeat center center",
      },
      title: '',
    };
  },
  created() {
    this.getTitle(49)
  },
  methods: {

    getTitle(id) {
      this.$tools.localStorageFn.get("CATEGORIES_LIST").forEach((item) => {
        if (item.id == id) {
          console.log('item', item)
          this.title = item.title;
        } else if (item.children.length > 0) {
          item.children.forEach((ele) => {
            console.log('ele', ele)
            if (ele.id == id) {
              this.title = ele.title;
            }
          })
        }
      })
    },
  },
};
</script>

<style lang="scss">
.phonePage05 {
  width: 100%;
  height: 100%;
  background: url(~@/assets/images/homeBg05.png) no-repeat center center;
  background-size: 100% 100%;
  padding: 12.5vh 2.25rem 0;
  position: relative;

  .pb_box {
    position: relative;
    padding-top: 6.0rem;
  }

  .pb_bg {
    position: absolute;
    top: 0;

    img {
      width: 11.0rem;
      height: 11.0rem;
    }
  }

  .pb_area {
    background: #fff;
    border-radius: 50%;
    height: 31.0rem;
    width: 31.0rem;
    padding: 3.2rem 3.6rem;
    position: relative;
    z-index: 10;
    margin: 0 auto;

    .pb_title {
      transform: translateY(6.0rem);
      opacity: 0;
      transition: 1s 0.6s;
      font-size: 2.6rem;
      font-family: JingZhe_XiaoWei;
      font-weight: 400;
      color: #023161;
      line-height: 2.8rem;
      text-align: center;
      margin-bottom: 1.8rem;
    }

    .pb_label {
      transform: translateY(6.0rem);
      opacity: 0;
      transition: 1s 0.8s;
      font-size: 1.2rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #023161;
      line-height: 2.0rem;
      text-align: center;
    }

    .t_box_btn {
      margin: 0 auto;
      margin-top: 2.4rem;
      width: 9.6rem;
      height: 2.8rem;
      background: url(~@/assets/images/icon_liaojiegengduo.png) no-repeat center center;
      background-size: 100%;
      text-align: center;
      line-height: 2.8rem;
      font-size: 1.2rem;
      font-family: Microsoft JhengHei UI;
      font-weight: 400;
      color: #023161;
    }
  }
}

.active {
  .phonePage05 {
    .pb_title {
      transform: translate(0);
      opacity: 1;
    }

    .pb_label {
      transform: translate(0);
      opacity: 1;
    }

    .pb_bg {
      img {
        animation-name: tilt-in-right-0;
        animation-timing-function: ease;
        animation-delay: 0s;
        animation-iteration-count: 1;
        animation-direction: linear;
        animation-fill-mode: none;
      }
    }
  }
}
</style>